(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-fountain-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fountain-reviews'))customElements.define('fountain-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.hyd-review-track');const buttons=[...this.querySelectorAll('button')];const sync=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));track.addEventListener('scroll',sync,{passive:true});this.resize=new ResizeObserver(sync);this.resize.observe(track);sync()}disconnectedCallback(){this.resize?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-hydration-purchase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hydration-buy-bar'))customElements.define('hydration-buy-bar',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.main=document.querySelector('product-info:has(.hyd-product-intro)');
    if(!this.main)return;
    const target=this.main.querySelector('.product-form__buttons');
    if(!target)return;
    const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
    this.edit=()=>{const group=this.main.querySelector('variant-selects')||this.main.querySelector('product-form');group?.scrollIntoView({behavior:motion(),block:'center'});group?.querySelector('input:checked,select,button')?.focus({preventScroll:true})};
    this.add=()=>{const submit=this.main.querySelector('.product-form__submit');if(submit&&!submit.disabled&&submit.getAttribute('aria-disabled')!=='true')submit.click()};
    this.querySelector('.hyd-buy-edit')?.addEventListener('click',this.edit);
    this.querySelector('.hyd-buy-add')?.addEventListener('click',this.add);
    this.sync=()=>{const price=this.main.querySelector('.price--on-sale .price-item--sale')||this.main.querySelector('.price__regular .price-item--regular');const output=this.querySelector('[data-hyd-price]');if(output&&price)output.textContent=price.textContent.trim();const options=[...this.main.querySelectorAll('variant-selects input:checked,variant-selects select')].map(e=>e.tagName==='SELECT'?e.selectedOptions[0]?.textContent.trim():e.value);this.querySelector('[data-hyd-choice]').textContent=this.dataset.refill==='true'?'One-time or every 8 months':options.filter(Boolean).join(' · ');const submit=this.main.querySelector('.product-form__submit');const add=this.querySelector('.hyd-buy-add');if(add){const busy=submit?.classList.contains('loading');const disabled=!submit||submit.disabled||submit.getAttribute('aria-disabled')==='true';add.disabled=disabled||busy;add.setAttribute('aria-busy',String(Boolean(busy)));add.textContent=disabled?add.dataset.soldLabel:add.dataset.defaultLabel}};
    this.observer=new IntersectionObserver(([entry])=>{this.hidden=entry.intersectionRatio>=0.5||entry.boundingClientRect.top>=window.innerHeight},{threshold:[0,0.5,1]});this.observer.observe(target);
    this.changes=new MutationObserver(this.sync);this.changes.observe(this.main,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});this.sync();
  }
  disconnectedCallback(){this.observer?.disconnect();this.changes?.disconnect();this.querySelector('.hyd-buy-edit')?.removeEventListener('click',this.edit);this.querySelector('.hyd-buy-add')?.removeEventListener('click',this.add)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-paw-stories"] && !Shopify.designMode) return;
  try {
    
function initPawStories(root) {
  const summary = document.querySelector('[data-fp-rating-summary]');
  if (summary) {
    document.querySelectorAll('[data-fp-rating-label]').forEach((label) => {
      label.textContent = summary.dataset.fpRatingSummary;
      const stars = label.closest('.fp-testimonial-link')?.querySelector('[data-fp-rating-icons]');
      if (stars) stars.hidden = false;
    });
  }
  root.querySelectorAll('.fp-story-grid').forEach((grid) => {
    if (grid.dataset.touchReady) return;
    grid.dataset.touchReady = 'true';
    grid.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'mouse') return;
      const card = event.target.closest('.fp-story-card');
      if (!card) return;
      grid.querySelectorAll('[data-emphasized]').forEach((other) => {
        if (other !== card) other.removeAttribute('data-emphasized');
      });
      card.setAttribute('data-emphasized', '');
    });
    grid.addEventListener('focusin', (event) => {
      grid.querySelectorAll('[data-emphasized]').forEach((card) => {
        if (card !== event.target.closest('.fp-story-card')) card.removeAttribute('data-emphasized');
      });
    });
  });
}
initPawStories(document);
document.addEventListener('shopify:section:load', (event) => initPawStories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
